import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import StaffGroupsApi from '@/services/apiServiceModules/staffGroupsApi.js'
const staffGroupsApi = new StaffGroupsApi()

export default class StaffGroupsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.STAFF_GROUPS, staffGroupsApi, {
			useCache: true,
		})
	}
}
